import {
  PrinterNotFoundError,
  QzNotRunningError,
  QzPermissionError,
  QzPrintError,
} from '../services/qzPrinterErrors';
import { logError } from '../config_and_helpers/logger';

const LOG_CONTEXT = 'directLabelPrintErrors';

/**
 * Map stock-item-labels API errors to user-facing strings.
 * @param {{ status?: number, messages?: string[] }} result
 */
export const mapLabelsFetchError = result => {
  if (result.status === 401 || result.status === 403) {
    return 'Not authorized to print labels for this order.';
  }
  if (result.status === 404) {
    return 'Order not found.';
  }
  if (result.status === 503) {
    return (
      result.messages?.[0] ||
      'Stock scan frontend URL is not configured on the server.'
    );
  }
  return result.messages?.[0] || 'Unable to prepare labels.';
};

/**
 * @param {Error} error
 */
export const mapPrintError = error => {
  if (error instanceof QzNotRunningError || error instanceof QzPermissionError) {
    return { code: error.code, message: error.message, needsPreview: true };
  }
  if (error instanceof PrinterNotFoundError) {
    return {
      code: error.code,
      message: 'The configured label printer was not found.',
      needsPrinterSelection: true,
      needsPreview: true,
    };
  }
  if (error instanceof QzPrintError) {
    return {
      code: error.code,
      message: error.message,
      needsPreview: true,
    };
  }
  logError(LOG_CONTEXT, 'unexpected print error', error);
  return {
    code: 'UNKNOWN',
    message: 'Unable to print labels. Try again or use Print Preview.',
    needsPreview: true,
  };
};
